import u from "dayjs";
function o(...t) {
  const a = t.map((e) => e.valueOf()), n = Math.min(...a);
  return u(n);
}
function s(...t) {
  const a = t.map((e) => e.valueOf()), n = Math.max(...a);
  return u(n);
}
function c(t, a, n) {
  return s(o(t, n), a);
}
export {
  c as useDateClamp,
  s as useMaxDate,
  o as useMinDate
};
